import { organizationData } from '@/store/helpers';
import { computed, Ref } from 'vue';
import { Priority, PriorityCollection, WorkType } from '@/api';

export function usePriorities({
  workTypes,
}: {
  workTypes?: Ref<Array<WorkType> | undefined>;
} = {}) {
  const { organization } = organizationData();

  const allPriorities = computed<Array<Priority>>(() => {
    let collections: Array<PriorityCollection> = [];
    if (workTypes?.value?.length) {
      workTypes.value.forEach((workType) => {
        const collection = organization.value?.priorityCollections.find(
          (c) => c.id === workType.priorityCollectionId
        );
        if (collection) {
          collections.push(collection);
        }
      });
    } else {
      if (!organization.value) {
        collections = [];
      } else {
        const defaultCollection = organization.value.priorityCollections.find(
          (c) => c.default
        );
        collections = defaultCollection
          ? [
              defaultCollection,
              ...(organization.value?.priorityCollections.filter(
                (d) => !d.default
              ) || {}),
            ]
          : [];
      }
    }
    const allPriorityIds = collections.reduce((acc: Array<string>, c) => {
      return [...acc, ...c.priorityIds];
    }, []);
    // unique priority ids
    const uniquePriorityIds = [...new Set(allPriorityIds)];
    const allPriorities: Array<Priority> = [];
    uniquePriorityIds.forEach((id) => {
      const priority = organization.value?.priorities.find((p) => p.id === id);
      if (priority) {
        allPriorities.push(priority);
      }
    });
    return allPriorities;
  });

  return {
    allPriorities,
  };
}
